import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../../_hooks/useClientId';
import { useRouteParams } from '../../../hooks/useRouteParams';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';

export enum GivingStrategy {
  DonationToDAF,
  OutrightGiftsToCharity,
  QualifiedCharitableDonations,
}

export enum KindOfProperty {
  Cash,
  Securities,
}

export enum Donor {
  Principal,
  Spouse,
}

export interface DafYear {
  year: number | null;
  type: number;
}

export interface Data {
  charityName: string | null;
  dafAccount: string | null;
  dafDonationEndYear: DafYear | null;
  dafDonationStartYear: DafYear | null;
  dafGrantAmount: number | null;
  dafGrantEndYear: DafYear | null;
  dafGrantStartYear: DafYear | null;
  donationAmount: number | null;
  donationEndYear: number | null;
  donationStartYear: number | null;
  donor: Donor | null;
  fundAccounts: string[] | null;
  givingStrategy: GivingStrategy | null;
  hasChildren: boolean | null;
  hasPartner: boolean | null;
  isRecurring: boolean | null;
  kindOfProperty: KindOfProperty | null;
  maximizeDonations: boolean | null;
  partnerDob: string | null;
  partnerName: string | null;
  principalDob: string | null;
  principalName: string | null;
  goalId: string | null;
}

export interface DafYearOption {
  label: string;
  value: number | null;
  type: number;
}

interface Options {
  givingStrategyOptions: { label: string; value: GivingStrategy }[];
  kindOfPropertyOptions: { label: string; value: KindOfProperty }[];
  donorOptions: { label: string; value: Donor }[];
  principalQcdYearOptions: number[];
  partnerQcdYearOptions: number[];
  donationYearOptions: number[];
  dafStartYearOptions: DafYearOption[];
  dafEndYearOptions: DafYearOption[];
  charityNameOptions: OptionType<string>[];
}

export interface WorkflowDTO {
  data: Data;
  options: Options;
}

interface FetcherParams {
  clientId: number;
  goalId: string | null;
}

const fetchWorkflow = async ({ clientId, goalId }: FetcherParams): Promise<WorkflowDTO> => {
  return authFetch(urlWithParams('/Consumer/CharitableGivingWorkflow', { clientId, goalId }));
};

export const useCharitableGivingQuery = () => {
  const clientId = useClientId();
  const { goalId } = useRouteParams();

  return useQuery(
    queryKeys.workflow(clientId, goalId),

    () => fetchWorkflow({ clientId, goalId }),

    {
      cacheTime: 0,
    },
  );
};
